"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styles = require("@qc-modules/styles");

var _ramda = require("ramda");

var _propTypes = require("prop-types");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _elements = require("../glyphs/elements");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var DistributionRegion = (0, _styledComponents["default"])(_primitives["default"].Text).withConfig({
  displayName: "distributor-list__DistributionRegion",
  componentId: "sc-uhuful-0"
})(["text-transform:uppercase;"]);

var Distributors = _styledComponents["default"].ul.withConfig({
  displayName: "distributor-list__Distributors",
  componentId: "sc-uhuful-1"
})(["list-style:none;margin:0;padding:0;"]);

var DisributorItem = _styledComponents["default"].li.withConfig({
  displayName: "distributor-list__DisributorItem",
  componentId: "sc-uhuful-2"
})(["margin-bottom:8px;&:last-child{margin-bottom:0;}"]);

var DisributorLink = (0, _styledComponents["default"])(_primitives["default"].Text).withConfig({
  displayName: "distributor-list__DisributorLink",
  componentId: "sc-uhuful-3"
})(["text-decoration:none;position:relative;pointer-event:none;color:", ";"], function (props) {
  return (0, _styles.colors)("blue", props);
});
var LinkArrow = (0, _styledComponents["default"])(_elements.NavCaretRight).withConfig({
  displayName: "distributor-list__LinkArrow",
  componentId: "sc-uhuful-4"
})(["vertical-align:middle;margin-left:8px;"]);
var propTypes = {
  // A list of company objects
  companies: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    // Unique identifier for key
    id: (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string]).isRequired,
    // Company name
    name: _propTypes.string,
    // Company url
    url: _propTypes.string
  })).isRequired,
  // Region
  region: _propTypes.string
};

var DistributorList = function DistributorList(_ref) {
  var region = _ref.region,
      companies = _ref.companies;
  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Box, {
    as: "section",
    mr: [4, 5]
  }, /*#__PURE__*/_react["default"].createElement(DistributionRegion, {
    color: "text-light-grey",
    fontSize: 0,
    letterSpacing: "1.5px",
    mb: 1,
    tag: "h1"
  }, region), /*#__PURE__*/_react["default"].createElement(Distributors, null, (0, _ramda.map)(function (_ref2) {
    var id = _ref2.id,
        url = _ref2.url,
        name = _ref2.name;
    return /*#__PURE__*/_react["default"].createElement(DisributorItem, {
      key: id
    }, /*#__PURE__*/_react["default"].createElement(DisributorLink, {
      fontSize: 1,
      fontWeight: 2,
      href: url,
      letterSpacing: "0.5px",
      tag: "a",
      target: "_blank"
    }, name, /*#__PURE__*/_react["default"].createElement(LinkArrow, {
      fill: "currentColor",
      height: "12px",
      ml: [1],
      width: "12px"
    })));
  }, companies)));
};

DistributorList.propTypes = propTypes;
var _default = DistributorList;
exports["default"] = _default;